import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_1.css";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import DefaultData from "../../CompanyData/DefaultData";

const Template_1_Packages = ({ onEnquireClick }) => {
  const companyId = DefaultData.DEFAULTCOMPANYID;
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const GetPackages = async () => {
      setIsLoading(true);
      try {
        const response = await apiService.getAll(
          `${config.GETPACKAGEBYCOMAPANYID}/${companyId}?type=Holiday`
        );
        setPackages(response.data);
      } catch (error) {
        console.error("Failed to fetch holiday data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    GetPackages();
  }, [companyId]);

  return (
    <section className="Template_1 section Template_1 featured-packages">
      <div className="Template_1 container">
        <div className="Template_1 section-title">
          <h2>Exciting Holiday Packages</h2>
          <p>Handpicked experiences for the discerning traveler</p>
        </div>

        {isLoading ? (
          <div className="Template_1 loading">Loading packages...</div>
        ) : packages.length === 0 ? (
          <div className="Template_1 no-data">
            No holiday packages available
          </div>
        ) : (
          <div className="Template_1 packages-grid">
            {packages.slice(0, 6).map((pkg) => (
              <div
                key={pkg.packageId}
                className="Template_1 package-card"
                onClick={() =>
                  navigate(`/template_1_packagedetails/${pkg.packageId}`)
                }
              >
                <div className="Template_1 package-image">
                  <img src={pkg.imageSrc} alt={pkg.packageName} />
                </div>
                <div className="Template_1 package-content">
                  <h3>{pkg.packageName}</h3>
                  <div className="Template_1 package-meta">
                    <span>
                      <i className="fas fa-clock"></i> {pkg.duration}
                    </span>
                    <span>
                      <i className="fas fa-user-friends"></i> {pkg.noOfPersons}
                    </span>
                  </div>
                  <div className="Template_1 package-price">
                    {pkg.price ? `INR ${pkg.price}` : "Contact for price"}
                  </div>
                  <button
                    className="Template_1 enquire-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEnquireClick(pkg);
                    }}
                  >
                    Enquire Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_1_Packages;
